import styled from 'styled-components';

export const HomePageContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: ${props => props.width > 500 ? "50%" : "80%"};
    padding-left: ${props => props.width > 500 ? "25%" : "10%"}
`;



